module.exports = __webpack_public_path__ + "static/media/Shark.c37c0e4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Shark.png
// module id = 1047
// module chunks = 0